<div class="map-container">
     <div id="projMap" [class.dark-theme]="theme$ === 'dark'">
         <button class="map-reset-btn" (click)="onResetMap()">
             <i class="pi pi-refresh"></i>
         </button>
         <button class="map-close-btn" (click)="onBackButton()">
               <i class="pi pi-chevron-left"></i>
         </button>
         <button class="markers-toggle-btn" (click)="markersToggle()">
             <i [ngClass]="toggleMarkersOff === true ? 'bi bi-pin-map' : 'bi bi-pin-map-fill'"></i>
         </button>
     </div>
 </div>
